<div class="quotation-register-container">
  <div class="card">
    <h2>User Registration</h2>
    
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="p-fluid">
      <div class="p-field">
        <label for="name">Full Name</label>
        <input 
          pInputText 
          id="name" 
          formControlName="name" 
          placeholder="Enter your full name"
          [ngClass]="{'p-invalid': registerForm.get('name')?.invalid && registerForm.get('name')?.touched}"
        >
        <small *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched" class="p-error">
          <span *ngIf="registerForm.get('name')?.errors?.['required']">Name is required</span>
          <span *ngIf="registerForm.get('name')?.errors?.['minlength']">Name must be at least 3 characters</span>
        </small>
      </div>

      <div class="p-field">
        <label for="email">Email</label>
        <input 
          pInputText 
          id="email" 
          formControlName="email" 
          placeholder="Enter your email"
          [ngClass]="{'p-invalid': registerForm.get('email')?.invalid && registerForm.get('email')?.touched}"
        >
        <small *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched" class="p-error">
          <span *ngIf="registerForm.get('email')?.errors?.['required']">Email is required</span>
          <span *ngIf="registerForm.get('email')?.errors?.['email']">Please enter a valid email</span>
        </small>
      </div>

      <div class="p-field">
        <label for="employeeNumber">Employee Number</label>
        <input 
          pInputText 
          id="employeeNumber" 
          formControlName="employeeNumber" 
          placeholder="Enter your employee number"
          [ngClass]="{'p-invalid': registerForm.get('employeeNumber')?.invalid && registerForm.get('employeeNumber')?.touched}"
        >
        <small *ngIf="registerForm.get('employeeNumber')?.invalid && registerForm.get('employeeNumber')?.touched" class="p-error">
          <span *ngIf="registerForm.get('employeeNumber')?.errors?.['required']">Employee number is required</span>
          <span *ngIf="registerForm.get('employeeNumber')?.errors?.['pattern']">Please enter a valid employee number (digits only)</span>
        </small>
      </div>

      <div class="p-field">
        <label for="password">Password</label>
        <p-password 
          id="password" 
          formControlName="password" 
          [feedback]="false" 
          placeholder="Enter your password"
          [ngClass]="{'p-invalid': registerForm.get('password')?.invalid && registerForm.get('password')?.touched}"
          [toggleMask]="true"
        ></p-password>
        <small *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched" class="p-error">
          <span *ngIf="registerForm.get('password')?.errors?.['required']">Password is required</span>
          <span *ngIf="registerForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters</span>
        </small>
      </div>

      <div class="p-field">
        <label for="role">Role</label>
        <p-dropdown 
          id="role" 
          [options]="roles" 
          formControlName="role" 
          optionLabel="name" 
          placeholder="Select a role"
          [ngClass]="{'p-invalid': registerForm.get('role')?.invalid && registerForm.get('role')?.touched}"
        ></p-dropdown>
        <small *ngIf="registerForm.get('role')?.invalid && registerForm.get('role')?.touched" class="p-error">
          Role is required
        </small>
      </div>

      <div class="p-field button-container">
        <button 
          pButton 
          type="submit" 
          label="Register" 
          class="p-button-raised p-button-primary" 
          [disabled]="registerForm.invalid"
        ></button>
      </div>
    </form>
  </div>

  <p-toast></p-toast>
</div>